/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} St_Mock_Exc_LabelInputs */

const en_st_mock_exc_label = /** @type {(inputs: St_Mock_Exc_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exceptions`)
};

const id_st_mock_exc_label = /** @type {(inputs: St_Mock_Exc_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pengecualian`)
};

/**
* | output |
* | --- |
* | "Exceptions" |
*
* @param {St_Mock_Exc_LabelInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const st_mock_exc_label = /** @type {((inputs?: St_Mock_Exc_LabelInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<St_Mock_Exc_LabelInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_st_mock_exc_label(inputs)
	return en_st_mock_exc_label(inputs)
});